<template>
  <div class="openapp-wrap">
    <button class="openapp-btn" type="button" @click="$emit('open-app')">
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'OpenAppButton',
  props: {
    text: { type: String, default: '打开app查看' }
  }
}
</script>

<style lang="scss" scoped>
.openapp-wrap {
  padding: 18px 16px calc(18px + env(safe-area-inset-bottom));
}

.openapp-btn {
  width: 100%;
  height: 52px;
  border-radius: 16px;
  background: #f15b5b;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 10px 24px rgba(241, 91, 91, 0.25);

  &:active {
    transform: scale(0.99);
    opacity: 0.9;
  }
}
</style>
